module.exports = __webpack_public_path__ + "static/media/facebook.99faa031.svg";